import { createContext } from 'react';
export var PreferencesEditorContext = createContext(undefined);
